import {h, Fragment} from "preact"
import { createContext } from "preact";
import { useContext, useState, useEffect } from "preact/hooks";

const GridContext = createContext();

export function GridProvider({ children }) {
    const [gridOption, setGridOption] = useState(() => {
        return localStorage.getItem("gridOption") || "4";
    });
    const [showOnModel, setShowOnModel] = useState(() => {
        return localStorage.getItem("showOnModel") === "true" || false; 
    });

    useEffect(() => {
        localStorage.setItem("gridOption", gridOption);
    }, [gridOption]);

    useEffect(() => {
        window.showOnModel = showOnModel;
        localStorage.setItem("showOnModel", showOnModel); 
    }, [showOnModel]);

    return (
        <GridContext.Provider value={{ gridOption, setGridOption, showOnModel, setShowOnModel }}>
            {children}
        </GridContext.Provider>
    );
}

export function useGrid() {
    return useContext(GridContext);
}